import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'

import MarkDown from '~/components/Helpers/MarkDown'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'
import ContactLink from '~/components/UI/Buttons/ContactLink/ContactLink'
import { CardProps } from '~/components/types/card'

const cardVariants = cva(
  'flex max-h-[500px] !h-[500px] flex-col p-xs-plus sm:basis-[calc(50%-12px)] sm:p-s  lg:p-m',
  {
    variants: {
      backgroundColour: {
        'ink-blue': 'bg-blue-d text-white',
        'mid-blue': 'bg-blue-m text-white',
        'light-blue': 'bg-blue-l-60 text-blue-d',
        chartreuse: 'bg-char text-blue-d',
        'light-pink': 'bg-pink-60 text-blue-d',
        'light-aqua': 'bg-green-60 text-blue-d',
        'light-purple': 'bg-purple-60 text-blue-d',
        'light-orange': 'bg-orange-60 text-blue-d',
        'light-grey': 'bg-grey-l text-blue-d',
        white: 'bg-white text-blue-d'
      }
    },
    defaultVariants: {
      backgroundColour: 'ink-blue'
    }
  }
)

const TextCard = ({ content, className }: CardProps) => {
  const {
    backgroundColour,
    copy,
    centred,
    buttons,
    contactLinks,
    userAction = 'link'
  } = content

  const button = buttons ? buttons[0] : null
  const contactLink = contactLinks ? contactLinks[0] : null

  const foregroundColour =
    backgroundColour === 'ink-blue' || backgroundColour === 'mid-blue'
      ? 'white'
      : 'ink-blue'

  return (
    <div
      className={cn(
        cardVariants({ backgroundColour }),
        className,
        `${centred && 'items-center text-center'}`
      )}
    >
      <MarkDown className='flex grow items-center' content={copy} />
      {button && userAction === 'link' && (
        <div className='mt-s w-fit'>
          <TertiaryLink data={button} colour={foregroundColour} />
        </div>
      )}
      {contactLink && userAction === 'contact-link' && (
        <div className='mt-s w-fit'>
          <ContactLink data={contactLink} colour={foregroundColour} />
        </div>
      )}
    </div>
  )
}

export default TextCard
